module.exports = __webpack_public_path__ + "static/img/mohuewm.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/mohuewm.png
// module id = 572
// module chunks = 0